import React from 'react';
import { Stack, RadioGroup } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LinkIcon from '@mui/icons-material/Link';
import PaymentMethodOption from './PaymentMethodOption.react';
import { PAYMENT_TYPE } from '../const';
import { useTranslation } from 'react-i18next';

const PaymentMethodGroup = ({ value, onChange }) => {
	const { t } = useTranslation();

	const handleChange = (val) => onChange(val);

	// const deadlineText = moment().add(5, 'days').format('D/M/YYYY');

	return (
		<RadioGroup value={value} onChange={(e) => handleChange(e.target.value)}>
			<Stack spacing={1.5}>
				<PaymentMethodOption
					value={PAYMENT_TYPE.CREDIT_CARD}
					selected={value === PAYMENT_TYPE.CREDIT_CARD}
					onChange={handleChange}
					title={t('Bookings.SettlePayment.CreditCard')}
					RightIcon={CreditCardIcon}
				/>

				<PaymentMethodOption
					value={PAYMENT_TYPE.SEND_PAY_LATER_LINK}
					selected={value === PAYMENT_TYPE.SEND_PAY_LATER_LINK}
					onChange={handleChange}
					title={t('Bookings.SettlePayment.SendAPaymentLink')}
					RightIcon={LinkIcon}
				/>

				{/*<PaymentMethodOption*/}
				{/*	value={PAYMENT_TYPE.BANK_TRANSFER}*/}
				{/*	selected={value === PAYMENT_TYPE.BANK_TRANSFER}*/}
				{/*	onChange={handleChange}*/}
				{/*	title={t('Bookings.SettlePayment.BankTransfer')}*/}
				{/*	subtitle={t('Bookings.SettlePayment.AvailableForTransfersUntil', { date: deadlineText })}*/}
				{/*	RightIcon={AccountBalanceIcon}*/}
				{/*/>*/}

				{/*<PaymentMethodOption*/}
				{/*	title={t('Bookings.SettlePayment.SplitPayments')}*/}
				{/*	RightIcon={DoNotDisturbOnOutlinedIcon}*/}
				{/*	disabled*/}
				{/*/>*/}
			</Stack>
		</RadioGroup>
	);
};

export default PaymentMethodGroup;
